<template>
  <ModalAddEditReminder
    ref="modal"
    v-if="modalShowAddReminder"
    @closeModal="closeModalAddEditReminder"
    @openAlertSuccess_ReminderCreated="openAlert_ReminderCreated"
    @openAlertSuccess_ReminderUpdated="openAlert_ReminderUpdated"
    :reminderData="reminderToEdit"
  />
  <transition name="fade">
    <AlertConfirmation
      v-if="alert_confirmation"
      @confirmNo="handle_clicked_no"
      @confirmYes="handle_clicked_yes"
      :animation_class="animation_alert_confirmation_class"
      text="Are you sure you want to delete this Reminder?"
      text_class="text-xl font-medium"
      title="Delete Reminder"
    />
  </transition>
  <section class="grid grid-cols-2 lg:grid-cols-4 gap-4 pb-40 h-fit">
    <PageHeader
      class="col-span-2 sm:col-span-1 lg:col-span-2"
      title="Reminder"
      subtitle="All Reminder"
    />
    <div
      class="col-span-2 sm:col-span-1 lg:col-span-2 flex justify-end items-end"
    >
      <Button
        button_id="new-reminder"
        button_text="&#43; New Reminder"
        @click="showModalAddReminder()"
      />
    </div>
    <Card card_class="col-span-2 lg:col-span-2">
      <div class="grid grid-cols-2 gap-2 items-center">
        <div>
          <!-- <span>Start Date</span> -->
          <InputForm
            v-model="startDate"
            @change="fetchReminders()"
            type="date"
            input_class="w-full"
            id="filter-start-date"
          />
        </div>
        <div>
          <!-- <span>End Date</span> -->
          <InputForm
            v-model="endDate"
            @change="fetchReminders()"
            type="date"
            input_class="w-full"
            id="filter-end-date"
          />
        </div>
      </div>
    </Card>
    <Card
      card_class="col-span-2 lg:col-span-4 max-h-[500px] overflow-y-auto"
      card_title="Today's Reminders"
    >
      <AlertSuccess v-if="alert_success" :text="alert_text" />

      <template v-if="todaysReminders.length === 0">
        <p>No data</p>
      </template>
      <template v-else>
        <DinamicTable :header_columns="table_header" th_class="text-left">
          <TableRow v-for="reminder in todaysReminders" :key="`today-${reminder.id}`">
            <TableCell>{{ reminder?.Customer?.name }}</TableCell>
            <TableCell>{{ reminder?.title }}</TableCell>
            <TableCell>{{ formatDate(reminder?.remind_date) }}</TableCell>
            <!-- <TableCell>{{ reminder?.transaction_id }}</TableCell> -->
            <TableCell>{{ reminder?.Branch?.name }}</TableCell>
            <!-- <TableCell>{{ reminder?.product_id }}</TableCell> -->
            <TableCell>{{ reminder?.customer_answer }}</TableCell>
            <TableCell>
              <RadioGroup
                :model-value="reminder.customer_answer_mood"
                class="grid grid-cols-3 gap-1"
                @update:model-value="(value) => updateReminderMood(reminder, value)"
              >
                <RadioGroupOption
                  as="template"
                  v-for="(item, index) in customer_answer_mood_data"
                  :key="`mood-today-${reminder.id}-${index}`"
                  :value="item.value"
                  v-slot="{ active, checked }"
                >
                  <div
                    @click="updateReminderMood(reminder, item.value)"
                    :class="[
                      'cursor-pointer focus:outline-none',
                      active ? 'ring-2 ring-white ring-offset-2' : '',
                      checked
                        ? 'ring-1 ring-white bg-white/20'
                        : 'bg-transparent text-gray-900 ring-0',
                      !active && !checked ? 'ring-inset' : '',
                      active && checked ? 'ring-2' : '',
                      'flex items-center justify-center rounded-md text-2xl p-1 font-semibold uppercase sm:flex-1',
                    ]"
                  >
                    {{ item.name }}
                  </div>
                </RadioGroupOption>
              </RadioGroup>
            </TableCell>
            <TableCell>
              <div class="flex items-center justify-center">
                <input
                  type="checkbox"
                  :id="`status-today-${reminder.id}`"
                  :checked="reminder.status === 'done'"
                  @change="handleStatusChange(reminder, $event)"
                  class="h-5 w-5 rounded-md border-gray-300 bg-transparent text-primary-500 focus:ring-primary-500"
                />
              </div>
            </TableCell>
            <TableCell class="flex gap-2">
              <TableButtonEdit
                path="#"
                :container_id="`btnEditReminder${reminder?.id}`"
                @click="editReminder(reminder)"
              />
              <TableButtonDelete
                @click="deleteReminder(reminder?.id)"
                path="#"
                :container_id="`btnDeleteReminder${reminder?.id}`"
              />
            </TableCell>
          </TableRow>
        </DinamicTable>
      </template>
      <!-- <Pagination
        :totalItems="pagination.totalItems"
        :perPage="parseInt(pagination.perPage)"
        :currentPage="parseInt(pagination.page)"
        :previousPageLink="pagination?.previousPageLink"
        :nextPageLink="pagination?.nextPageLink"
        @page-changed="fetchReminders"
      /> -->
    </Card>

    <Card
      card_class="col-span-2 lg:col-span-4 max-h-[500px] overflow-y-auto"
      card_title="Coming Reminders"
    >
      <AlertSuccess v-if="alert_success" :text="alert_text" />

      <template v-if="comingSoonReminders.length <= 0">
        <p>No data</p>
      </template>
      <template v-else>
        <DinamicTable :header_columns="table_header" th_class="text-left">
          <TableRow
            v-for="reminder in comingSoonReminders"
            :key="`coming-${reminder.id}`"
          >
            <TableCell>{{ reminder?.Customer?.name }}</TableCell>
            <TableCell>{{ reminder?.title }}</TableCell>
            <TableCell>{{ formatDate(reminder?.remind_date) }}</TableCell>
            <!-- <TableCell>{{ reminder?.transaction_id }}</TableCell> -->
            <TableCell>{{ reminder?.Branch?.name }}</TableCell>
            <!-- <TableCell>{{ reminder?.product_id }}</TableCell> -->
            <TableCell>{{ reminder?.customer_answer }}</TableCell>
            <TableCell>
              <RadioGroup
                :model-value="reminder.customer_answer_mood"
                class="grid grid-cols-3 gap-1"
                @update:model-value="
                  (value) => updateReminderMood(reminder, value)
                "
              >
                <RadioGroupOption
                  as="template"
                  v-for="(item, index) in customer_answer_mood_data"
                  :key="index"
                  :value="item.value"
                  v-slot="{ active, checked }"
                >
                  <div
                    @click="updateReminderMood(reminder, item.value)"
                    :class="[
                      'cursor-pointer focus:outline-none',
                      active ? 'ring-2 ring-white ring-offset-2' : '',
                      checked
                        ? 'ring-1 ring-white bg-white/20'
                        : 'bg-transparent text-gray-900 ring-0',
                      !active && !checked ? 'ring-inset' : '',
                      active && checked ? 'ring-2' : '',
                      'flex items-center justify-center rounded-md text-2xl p-1 font-semibold uppercase sm:flex-1',
                    ]"
                  >
                    {{ item.name }}
                  </div>
                </RadioGroupOption>
              </RadioGroup>
            </TableCell>
            <TableCell>
              <div class="flex items-center justify-center">
                <input
                  type="checkbox"
                  :id="`status-${reminder.id}`"
                  :checked="reminder.status === 'done'"
                  @change="
                    updateReminderStatus(reminder, $event.target.checked)
                  "
                  class="h-5 w-5 rounded-md border-gray-300 bg-transparent text-primary-500 focus:ring-primary-500"
                />
              </div>
            </TableCell>
            <TableCell class="flex gap-2">
              <TableButtonEdit
                path="#"
                :container_id="`btnEditReminder${reminder?.id}`"
                @click="editReminder(reminder)"
              />
              <TableButtonDelete
                @click="deleteReminder(reminder?.id)"
                path="#"
                :container_id="`btnDeleteReminder${reminder?.id}`"
              />
            </TableCell>
          </TableRow>
        </DinamicTable>
      </template>
    </Card>
    <Card
      card_class="col-span-2 lg:col-span-4 max-h-[500px] overflow-y-auto"
      card_title="Previous Done Reminders"
    >
      <AlertSuccess v-if="alert_success" :text="alert_text" />

      <template v-if="previousReminders.length === 0">
        <p>No data</p>
      </template>
      <template v-else>
        <DinamicTable :header_columns="table_header" th_class="text-left">
          <TableRow v-for="reminder in previousReminders" :key="`previous-${reminder.id}`">
            <TableCell>{{ reminder?.Customer?.name }}</TableCell>
            <TableCell>{{ reminder?.title }}</TableCell>
            <TableCell>{{ formatDate(reminder?.remind_date) }}</TableCell>
            <!-- <TableCell>{{ reminder?.transaction_id }}</TableCell> -->
            <TableCell>{{ reminder?.Branch?.name }}</TableCell>
            <!-- <TableCell>{{ reminder?.product_id }}</TableCell> -->
            <TableCell>{{ reminder?.customer_answer }}</TableCell>
            <TableCell>
              <RadioGroup
                :model-value="reminder.customer_answer_mood"
                class="grid grid-cols-3 gap-1"
                @update:model-value="(value) => updateReminderMood(reminder, value)"
              >
                <RadioGroupOption
                  as="template"
                  v-for="(item, index) in customer_answer_mood_data"
                  :key="`mood-previous-${reminder.id}-${index}`"
                  :value="item.value"
                  v-slot="{ active, checked }"
                >
                  <div
                    @click="updateReminderMood(reminder, item.value)"
                    :class="[
                      'cursor-pointer focus:outline-none',
                      active ? 'ring-2 ring-white ring-offset-2' : '',
                      checked
                        ? 'ring-1 ring-white bg-white/20'
                        : 'bg-transparent text-gray-900 ring-0',
                      !active && !checked ? 'ring-inset' : '',
                      active && checked ? 'ring-2' : '',
                      'flex items-center justify-center rounded-md text-2xl p-1 font-semibold uppercase sm:flex-1',
                    ]"
                  >
                    {{ item.name }}
                  </div>
                </RadioGroupOption>
              </RadioGroup>
            </TableCell>
            <TableCell>
              <div class="flex items-center justify-center">
                <input
                  type="checkbox"
                  :id="`status-previous-${reminder.id}`"
                  :checked="reminder.status === 'done'"
                  @change="handleStatusChange(reminder, $event)"
                  class="h-5 w-5 rounded-md border-gray-300 bg-transparent text-primary-500 focus:ring-primary-500"
                />
              </div>
            </TableCell>
            <TableCell class="flex gap-2">
              <TableButtonEdit
                path="#"
                :container_id="`btnEditReminder${reminder?.id}`"
                @click="editReminder(reminder)"
              />
              <TableButtonDelete
                @click="deleteReminder(reminder?.id)"
                path="#"
                :container_id="`btnDeleteReminder${reminder?.id}`"
              />
            </TableCell>
          </TableRow>
        </DinamicTable>
      </template>
    </Card>
  </section>
</template>

<script>
import Card from "@/components/organisms/Card.vue";
import PageHeader from "@/components/molecules/PageHeader.vue";
import DinamicTable from "@/components/organisms/DinamicTable.vue";
import Button from "@/components/buttons/Button.vue";
import TableRow from "@/components/atoms/table/TableRow.vue";
import TableCell from "@/components/atoms/table/TableCell.vue";
import TableButtonEdit from "@/components/atoms/table/TableButtonEdit.vue";
import TableButtonDelete from "@/components/atoms/table/TableButtonDelete.vue";
import AlertConfirmation from "@/components/alerts/AlertConfirmation.vue";
import ModalAddEditReminder from "@/components/modals/ModalAddEditReminder.vue";
import TableButtonView from "@/components/atoms/table/TableButtonView.vue";
import AlertSuccess from "@/components/alerts/AlertSuccess.vue";
import Pagination from "@/components/organisms/Pagination.vue";
import { TrashIcon, PencilIcon } from "@heroicons/vue/24/solid";
import { mapGetters, mapActions } from "vuex";
import { formatDate } from "@/helpers/formating";
import InputForm from "@/components/form/InputForm.vue";
import { RadioGroup, RadioGroupOption } from "@headlessui/vue";

export default {
  name: "Reminders",
  components: {
    PageHeader,
    DinamicTable,
    Card,
    Button,
    TableRow,
    TableCell,
    TableButtonEdit,
    TableButtonDelete,
    AlertConfirmation,
    ModalAddEditReminder,
    TableButtonView,
    AlertSuccess,
    Pagination,
    TrashIcon,
    PencilIcon,
    InputForm,
    RadioGroup,
    RadioGroupOption,
  },
  data() {
    const today = new Date();
    const nextWeek = new Date();
    nextWeek.setDate(today.getDate() + 7);
    const prevMonth = new Date();
    prevMonth.setDate(today.getDate() - 30);

    return {
      table_header: [
        // "No",
        "Customer",
        "Title",
        "Remind Date",
        // "trx",
        // "product",
        "branch",
        "answer",
        "Feedback",
        "Status",
        "Action",
      ],

      alert_confirmation: false,
      animation_alert_confirmation_class: "",
      alert_success: false,
      alert_text: "",

      reminder: {
        status: "not done",
        customer_answer_mood: "",
      },

      customer_answer_mood_data: [
        { name: "😡", value: "Bad" },
        { name: "😐", value: "OK" },
        { name: "😃", value: "Good" },
      ],

      reminderIdToDelete: null,
      reminderToEdit: null,
      modalShowAddReminder: false,
      reminderStatuses: new Map(),
      reminderMoods: new Map(),

      today: today,
      todayDate: today.toISOString().split("T")[0], // New variable for today's date
      startDate: prevMonth.toISOString().split("T")[0], // Default to today
      endDate: nextWeek.toISOString().split("T")[0], // Default to today + 7 days
    };
  },
  computed: {
    ...mapGetters("reminders", ["allReminders", "pagination"]),

    todaysReminders() {
      return this.filteredReminder
        .filter((reminder) => {
          const remind_dt = new Date(reminder.remind_date);
          const dt = remind_dt.toISOString().split("T")[0];
          return (
            (reminder.status === "not done" && remind_dt <= this.today) ||
            dt === this.todayDate
          );
        })
        .map(reminder => ({
          ...reminder,
          status: reminder.status || 'not done',
          customer_answer_mood: reminder.customer_answer_mood || '',
        }));
    },

    comingSoonReminders() {
      const today = new Date(this.todayDate);
      return this.filteredReminder
        .filter((reminder) => {
          const remindDate = new Date(reminder.remind_date);
          return remindDate > today;
        })
        .sort((a, b) => new Date(a.remind_date) - new Date(b.remind_date))
        .map((reminder) => ({
          ...reminder,
          // Ensure each reminder has these properties set
          status: reminder.status || "not done",
          customer_answer_mood: reminder.customer_answer_mood || "",
        }));
    },

    previousReminders() {
      return this.filteredReminder
        .filter((reminder) => {
          return (
            reminder.status === "done" &&
            new Date(reminder.remind_date).toISOString().split("T")[0] <=
              this.todayDate
          );
        })
        .sort((a, b) => new Date(b.done_at) - new Date(a.done_at))
        .map(reminder => ({
          ...reminder,
          status: reminder.status || 'not done',
          customer_answer_mood: reminder.customer_answer_mood || '',
        }));
    },

    filteredReminder() {
      // First map the data to ensure all properties are set
      const mappedReminders = this.allReminders.map((reminder) => ({
        ...reminder,
        customer_answer_mood: reminder.customer_answer_mood || "",
        status: reminder.status || "not done",
      }));

      // Then sort the reminders
      return mappedReminders.sort((a, b) => {
        // Convert status to numeric value for sorting
        const statusOrder = {
          "not done": 0,
          done: 1,
        };

        const statusA = statusOrder[a.status] || 0;
        const statusB = statusOrder[b.status] || 0;

        // Sort by status first
        if (statusA !== statusB) {
          return statusA - statusB;
        }

        // If status is the same, maintain the original order
        // You can add additional sorting criteria here if needed
        // For example, sort by date or title within each status group
        return 0;
      });
    },
  },
  watch: {
    allReminders: {
      handler(newReminders) {
        // Update the status tracking when reminders change
        newReminders.forEach((reminder) => {
          this.reminderStatuses.set(reminder.id, reminder.status);
          this.reminderMoods.set(reminder.id, reminder.customer_answer_mood);
        });
      },
      deep: true,
    },
  },
  methods: {
    formatDate,
    ...mapActions("reminders", [
      "fetchReminders",
      "updateReminder",
      "deleteReminderById",
      "clearReminders",
    ]),

    async fetchReminders(
      remind_from = this.startDate,
      remind_to = this.endDate
    ) {
      // console.log("remind_from: ", remind_from);
      // console.log("remind_to: ", remind_to);
      const params = {
        // remind_date,
        remind_from,
        remind_to,
        order: "remind_date",
        sort: "ASC",
      };
      await this.$store.dispatch("reminders/fetchReminders", params);
    },

    async updateReminderStatus(reminder, newStatus) {
      try {
        const updatedReminder = await this.updateReminder({
          id: reminder.id,
          status: newStatus ? "done" : "not done", // Konversi status sesuai dengan backend
          done_at: newStatus ? new Date().toISOString() : null,
        });
        // Perbarui nilai status di frontend sesuai dengan respon dari backend
        reminder.status = updatedReminder.status;
        // console.log(`Status reminder ID ${reminder.id} diperbarui ke ${updatedReminder.status}`);
      }
      catch (error) {
        console.error(
          `Gagal memperbarui status reminder ID ${reminder.id}`,
          error
        );
      }
      finally {
        this.fetchReminders();
      }
    },
    async handleStatusChange(reminder, event) {
      const newStatus = event.target.checked ? 'done' : 'not done';
      const originalStatus = reminder.status;
      
      try {
        // Directly update the property
        reminder.status = newStatus;
        
        // Update in backend
        await this.updateReminder({
          id: reminder.id,
          status: newStatus,
          done_at: newStatus === 'done' ? this.todayDate : null,
        });

        // Update status in tracking Map
        this.reminderStatuses.set(reminder.id, newStatus);
        
        // Refresh data to ensure consistency
        await this.fetchReminders();
      }
      catch (error) {
        console.error('Failed to update reminder status:', error);
        // Revert to original state on error
        reminder.status = originalStatus;
        event.target.checked = originalStatus === 'done';
        // Revert status in tracking Map
        this.reminderStatuses.set(reminder.id, originalStatus);
      }
    },
    async updateReminderMood(reminder, mood) {
      if (!reminder || !mood) return;
      
      const originalMood = reminder.customer_answer_mood;

      try {
        // Directly update the property
        reminder.customer_answer_mood = mood;
        
        // Update in backend
        await this.updateReminder({
          id: reminder.id,
          customer_answer_mood: mood,
        });

        // Update mood in tracking Map
        this.reminderMoods.set(reminder.id, mood);
        
        // Refresh data
        await this.fetchReminders();
      }
      catch (error) {
        console.error('Failed to update reminder mood:', error);
        // Revert to original state on error
        reminder.customer_answer_mood = originalMood;
        this.reminderMoods.set(reminder.id, originalMood);
      }
    },

    showAlertConfirmation() {
      this.alert_confirmation = true;
    },
    handle_clicked_no() {
      this.alert_confirmation = false;
      this.animation_alert_confirmation_class = "animate__backOutUp";
      this.reminderIdToDelete = null;
    },
    handle_clicked_yes() {
      this.alert_confirmation = false;
      this.animation_alert_confirmation_class = "animate__backOutUp";
      this.deleteReminderById(this.reminderIdToDelete);
      this.fetchReminders();
      this.reminderIdToDelete = null;
      this.alert_success = true;
      this.alert_text = "Reminder deleted successfully!";
      setTimeout(() => {
        this.alert_success = false;
        this.alert_text = "Reminder added successfully!";
      }, 1500);
    },

    showModalAddReminder() {
      this.reminderToEdit = null;
      this.modalShowAddReminder = true;
    },
    async closeModalAddEditReminder() {
      this.modalShowAddReminder = false;
      await this.fetchReminders();
    },
    openAlert_ReminderCreated() {
      this.alert_success = true;
      this.alert_text = "Reminder added successfully!";

      setTimeout(() => {
        this.alert_success = false;
        this.alert_text = "Reminder added successfully!";
      }, 1500);
    },
    openAlert_ReminderUpdated() {
      this.alert_success = true;
      this.alert_text = "Reminder updated successfully!";

      setTimeout(() => {
        this.alert_success = false;
        this.alert_text = "Reminder updated successfully!";
      }, 1500);
    },
    deleteReminder(id) {
      this.reminderIdToDelete = id;
      this.showAlertConfirmation();
    },
    editReminder(reminder) {
      this.reminderToEdit = reminder;
      this.modalShowAddReminder = true;
    },
  },
  async created() {
    this.clearReminders();
    await this.fetchReminders();
  },
};
</script>
